import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { PanelModule } from '../../../modules/panel.module';
import { UiSettingsComponent } from '../../ui-settings/ui-settings.component';
import { TagSelectorComponent } from '../tag-selector/tag-selector.component';
import { Constants } from '../../../model/common.model';

@Component({
  selector: 'brt-menu-save',
  standalone: true,
  imports: [PanelModule, UiSettingsComponent, TagSelectorComponent],
  templateUrl: './menu-save.component.html',
  styleUrl: './menu-save.component.scss'
})
export class MenuSaveComponent {
  orderSources = Constants.OrderSources;
  basePath = this.route.snapshot.data['basePath'] || '/';
  businessId: string;
  private _menu: any;
  get menu() { return this._menu; }
  @Input() set menu(value: any) {
    this._menu = value;
    if (this._menu && !this._menu.SourcePrice) this._menu.SourcePrice = [];
  }
  @Output() saved = new EventEmitter<any>();
  get isMainComponent() { return this.route.component == <any>this.constructor; }
  constructor(private route: ActivatedRoute, private router: Router, private menuService: MenuService) {
    if (this.isMainComponent)
      route.params.subscribe(async params => {
        this.businessId = params['bid'];
        var menuId = params['mid'];
        this.menu = !menuId ? { BusinessId: this.businessId } : await this.menuService.getMenu(menuId);
      });
  }

  async save(navigate = true) {
    await this.menuService.saveMenu(this.menu);
    if (this.saved.observed) this.saved.emit(this.menu);
    else if (navigate)  {
        if(window.history?.length) window.history.back()      
        else await this.router.navigate([this.basePath, 'menu', this.businessId]);
    }
  }
}
